export const SITETITLE = 'Matriye Academy';
export const STUDENTLINK = 'https://t-tstudent.matriyeacademy.com';